import {
  nonJsSourceExtensions,
  base64AssetExtensions,
  sourceRegex,
  textExtensions,
} from '@ms-cloudpack/path-utilities';
import path from 'path';

const supportedNonJsExtensions = [...base64AssetExtensions, ...nonJsSourceExtensions, ...textExtensions];

// Note: excluded extensions only need to contain things that are allowed by supportedExtensions but using
// an extended syntax that we don't want to support. For example, we want to support .ts files but not .d.ts.
const excludedExtensions = ['.d.ts'];

/**
 * Returns true if the file path is a valid bundle-able file extension. This is used to filter exports maps out
 * to ensure we prevent trying to bundle things that bundlers don't support. We can bundle things like TS,
 * JS, CSS, SCSS, JSON, and even text extensions like .txt and .html. These formats all will produce javascript
 * modules. "Valid" is defined by what the bundler abstraction expects. In the future we may want this code to be
 * provided by the plugin itself so that it owns what's "supported".
 */
export function isValidBundleEntry(filePath: string): boolean {
  filePath = filePath.toLowerCase();
  const ext = path.extname(filePath);
  const isSupported = sourceRegex.test(ext) || supportedNonJsExtensions.includes(ext);
  const isExcluded =
    excludedExtensions.some((excludedExt) => filePath.endsWith(excludedExt)) ||
    // Exclude files that start with an underscore, as they are typically partials or other non-entry files.
    // https://sass-lang.com/documentation/at-rules/import/#partials
    (ext === '.scss' && path.basename(filePath).startsWith('_'));

  return isSupported && !isExcluded;
}
